import React from "react";
import { SectionGroup } from "../Sidebar/Filters";
import FilterChip from "./FilterChip";

interface QuickFilterProps {
  filters: SectionGroup[] | undefined;
  itemClass: string;
  setIsFilterRemoved?: (isCleared: boolean) => void;
}

const QuickFilter = ({
  filters,
  itemClass,
  setIsFilterRemoved,
}: QuickFilterProps) => {
  return (
    <>
      {filters?.map((filterGroup) => (
        <>
          {filterGroup?.groupItems.map(
            (filter) =>
              filter.isSelected && (
                <li className={`md:flex-shrink-0 list-none pr-1 ${itemClass}`}>
                  <FilterChip
                    filterName={filterGroup.groupName}
                    filterValue={
                      filter.displayAsFraction && filter.labelAsFraction
                        ? filter.labelAsFraction
                        : filter.label
                    }
                    filterUrl={filter.filterUrl}
                    setIsFilterRemoved={setIsFilterRemoved}
                  />
                </li>
              ),
          )}
        </>
      ))}
    </>
  );
};

export default QuickFilter;
